import { TimelineMax } from 'gsap/TweenMax';
import store from '@/store';

export const buttonToClose = (el = document) => {
  const btnDsk = el.querySelector('.page-item__link--dsk');
  const btnMbl = el.querySelector('.page-item__link--mbl');
  const btnMblArrow = btnMbl.querySelector('.page-item__arrow');
  const btnMblContent = btnMbl.querySelector('.page-item__link-caption');
  const tl = new TimelineMax();

  tl.addLabel('start')
    .to(btnDsk, 0.5, {
      y: -20,
      autoAlpha: 0,
    }, 'start')
    .to(btnMbl, 0.3, {
      autoAlpha: 0,
    }, 'start')
    .to(btnMbl, 0.01, {
      y: -180,
      onComplete: () => {
        btnMblContent.innerHTML = 'Close';
        btnMblArrow.innerHTML = '×';
      },
    }, 'start+0.3')
    .to(btnMbl, 0.3, {
      autoAlpha: 1,
    }, 'start+=0.5');

  return tl;
};

export const buttonToDiscover = (el = document) => {
  const btnDsk = el.querySelector('.page-item__link--dsk');
  const btnMbl = el.querySelector('.page-item__link--mbl');
  const btnMblArrow = btnMbl.querySelector('.page-item__arrow');
  const btnMblContent = btnMbl.querySelector('.page-item__link-caption');
  btnMblArrow.innerHTML = '›';
  const tl = new TimelineMax();

  tl.addLabel('start')
    .fromTo(btnDsk, 0.5, {
      y: 20,
      autoAlpha: 0,
    }, {
      y: 0,
      autoAlpha: 1,
    }, 'start')
    .to(btnMbl, 0.2, {
      autoAlpha: 0,
    }, 'start')
    .to(btnMbl, 0.01, {
      y: 0,
      onComplete: () => {
        btnMblContent.innerHTML = 'Discover';
        btnMblArrow.innerHTML = '>';
      },
    }, 'start+0.3')
    .to(btnMbl, 0.3, {
      autoAlpha: 1,
    }, 'start+=0.5');

  return tl;
};

export const buttonIn = (el = document, type = 'default') => {
  const btnDsk = el.querySelector('.button--dsk');
  const btnMbl = el.querySelector('.button--mbl');
  const tl = new TimelineMax();

  tl.addLabel('start');

  if (type === 'default') {
    tl.from(btnDsk, 0.5, { y: 20, autoAlpha: 0 }, 'start');
  } else {
    tl.set(btnDsk, { autoAlpha: 0 }, 'start');
  }

  if (btnMbl !== null) {
    const btnMblArrow = btnMbl.querySelector('.button__arrow');
    const btnMblContent = btnMbl.querySelector('.button__caption');
    if (store.state.route.name !== 'buyNow') btnMblArrow.innerHTML = type === 'default' ? '›' : '×';
    if (store.state.route.name !== 'buyNow') btnMblContent.innerHTML = type === 'default' ? 'Discover' : 'Close';

    tl.from(btnMblContent, 0.3, {
      y: 20,
      autoAlpha: 0,
    }, 'start')
      .from(btnMblArrow, 0.3, {
        y: 20,
        autoAlpha: 0,
      }, 'start+=0.18');
  }

  return tl;
};

export const buttonInPage = (el = document, type = 'default') => {
  const btnDsk = el.querySelector('.button--dsk');
  const btnMbl = el.querySelector('.button--mbl');
  const tl = new TimelineMax();

  tl.addLabel('start');

  if (type === 'default') {
    tl.from(btnDsk, 0.5, { y: 20, autoAlpha: 0 }, 'start');
  } else {
    tl.set(btnDsk, { autoAlpha: 0 }, 'start');
  }

  if (btnMbl !== null) {
    const btnMblArrow = btnMbl.querySelector('.button__arrow');
    const btnMblContent = btnMbl.querySelector('.button__caption');
    if (store.state.route.name !== 'buyNow') btnMblArrow.innerHTML = type === 'default' ? '›' : '×';
    if (store.state.route.name !== 'buyNow') btnMblContent.innerHTML = type === 'default' ? 'Discover' : 'Close';

    tl.to(btnMbl, 0.01, { y: -180 }, 'start')
      .from(btnMblContent, 0.3, {
        y: 20,
        autoAlpha: 0,
      }, 'start')
      .from(btnMblArrow, 0.3, {
        y: 20,
        autoAlpha: 0,
      }, 'start+=0.18');
  }

  return tl;
};

export const buttonInLoader = (el = document) => {
  const btnDsk = el.querySelector('.button--dsk');
  const btnMbl = el.querySelector('.button--mbl');
  const tl = new TimelineMax();

  tl.addLabel('start');

  tl.fromTo(btnDsk, 0.5, {
    y: 20,
    autoAlpha: 0,
  }, {
    y: 0,
    autoAlpha: 1,
  }, 'start');

  if (btnMbl !== null) {
    const btnMblArrow = btnMbl.querySelector('.button__arrow');
    const btnMblContent = btnMbl.querySelector('.button__caption');

    tl.fromTo(btnMblContent, 0.3, {
      y: 20,
      autoAlpha: 0,
    }, {
      y: 0,
      autoAlpha: 1,
    }, 'start')
      .fromTo(btnMblArrow, 0.3, {
        y: 20,
        autoAlpha: 0,
      }, {
        y: 0,
        autoAlpha: 1,
      }, 'start+=0.18');
  }

  return tl;
};

export const buttonOut = (el = document) => {
  const btnDsk = el.querySelector('.button--dsk');
  const btnMbl = el.querySelector('.button--mbl');

  const tl = new TimelineMax();

  tl.addLabel('start')
    .to(btnDsk, 0.5, {
      y: -20,
      autoAlpha: 0,
    }, 'start');

  if (btnMbl !== null) {
    const btnMblArrow = btnMbl.querySelector('.button__arrow');
    const btnMblContent = btnMbl.querySelector('.button__caption');

    tl.to(btnMblContent, 0.3, {
      y: -20,
      autoAlpha: 0,
    }, 'start')
      .to(btnMblArrow, 0.3, {
        y: -20,
        autoAlpha: 0,
      }, 'start+=0.18');
  }

  return tl;
};

export const buttonSetLoader = (el = document) => {
  const btnDsk = el.querySelector('.button--dsk');
  const btnMbl = el.querySelector('.button--mbl');
  const tl = new TimelineMax();

  tl.addLabel('start');

  tl.set(btnDsk, {
    autoAlpha: 0,
  }, 'start');

  if (btnMbl !== null) {
    const btnMblArrow = btnMbl.querySelector('.button__arrow');
    const btnMblContent = btnMbl.querySelector('.button__caption');

    tl.set(btnMblContent, {
      autoAlpha: 0,
    }, 'start')
      .set(btnMblArrow, {
        autoAlpha: 0,
      }, 'start');
  }

  return tl;
};
